<template>
  <div v-if="transaction">
    <add-mobile-money-account
      :is-active.sync="isAdding"
      @added="accountAdded"
      :owner="transaction.source_user"
    />
    <data-table
      title="Mobile Money Accounts"
      ref="table"
      :url="url"
      :headers="headers"
      searchable
      :archive="false"
      @update-archived="(status) => (this.showArchived = status)"
    >
      <template slot="action.icons">
        <v-btn color="primary" @click="isAdding = true">
          Add Mobile Account
          <v-icon class="ml-2" color="light-blue lighten-4">
            mdi-account-plus
          </v-icon>
        </v-btn>
      </template>

      <template slot="item.status" slot-scope="{ item }">
        <div class="d-flex">
          <div>
            <div v-if="transaction.payout.data['mobile_money_account_id'] == item.id">
              <v-btn color="default" disabled>
                Linked Mobile money account
              </v-btn>
            </div>
            <div v-else>
              <v-btn color="success" @click="linkToCashout(item)">
                Link to this Cashout
              </v-btn>
            </div>
          </div>
          <v-btn color="default" class="ml-2" @click="showDetails(item)">
            view details
          </v-btn>
        </div>
      </template>
    </data-table>
  </div>
</template>

<script>
export default {
  components: { AddMobileMoneyAccount: require("./addMobileMoneyAccountForm").default },
  props: {
    transaction: { required: true },
  },

  data() {
    return {
      currentFilter: "all",
      isAdding: false,
      accounts: null,
      showArchived: false,
      headers: this.pairTableLabelWithValue({
        Title: "title",
        "Account Name": "owner_name",
        "Phone Number": "phone_number",
        Operator: "operator",
        Country: "country",
        Status: "status",
      }),
    };
  },
  computed: {
    url() {
      return `api/v1/userMMAccounts/all/${this.transaction.source_user_id}`;
    },
  },
  watch: {
    url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
    showArchived: function () {
      this.url = `/api/v1/userMMAccounts/all/${this.transaction.source_user_id}`;
    },
  },
  methods: {
    showDetails(account) {
      this.$router.push({ name: "mobilemoney.show", params: { id: account.id } });
    },
    updateAccount(account) {
      if (account) {
        this.account = account;
      }
    },
    linkToCashout(account) {
      console.log(account);
      Notify.confirm(`Please Confirm to Link this mobile money account`).then(() => {
        this.$http
          .post(`/api/v1/cashout/mobile-money-account/${this.transaction.id}/switch`, {
            mobile_money_account_id: account.id,
          })
          .then((result) => {
            Notify.success(result.message);
            window.location.reload();
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error) => {
            Notify.error(error.message);
          });
      });
    },
    accountAdded({ message }) {
      this.isAdding = false;
      this.$refs.table.fetchData();
      Notify.success(message);
    },
  },
};
</script>
